import { socket } from "../index";

const emitPick = (
  pick: string
) => {
  socket?.emit('PICK', {
    pick,
  });
}

export default emitPick;